import {Grid, Typography, Box, ButtonBase} from "@mui/material";
import blogsData from "../../Data/Blogs.json";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Lista_Blogs from "./Componentes/SubComponentes/Lista_Blogs";
import Lista from "./Componentes/SubComponentes/Lista";
import Contacto_Home from "./Componentes/Contacto_Home";

const Blogs_Home = () => {
    const { sCell } = useResponsive();

    return (
        <>
            <Helmet>
                {/* 🔹 Title optimizado */}
                <title>Blog de Mantenimiento Locativo en Cali | SST y Adecuaciones Técnicas</title>

                {/* 🔹 Meta descripción (≤155 caracteres) */}
                <meta
                    name="description"
                    content="Artículos sobre mantenimiento locativo, adecuaciones técnicas y SST en Cali. Guías para empresas y copropiedades."
                />

                {/* 🔹 Keywords alineadas */}
                <meta
                    name="keywords"
                    content="mantenimiento locativo Cali, SST Colombia, adecuaciones locativas, gestión de mantenimiento, infraestructura locativa, blog mantenimiento"
                />

                {/* 🔹 Robots */}
                <meta name="robots" content="index, follow" />

                {/* 🔹 Canonical */}
                <link rel="canonical" href="https://espaciocompacto.com/blogs/" />

                {/* 🔹 Open Graph */}
                <meta property="og:title" content="Blog de Mantenimiento Locativo en Cali | Espacio Compacto" />
                <meta
                    property="og:description"
                    content="Contenido técnico sobre SST, mantenimiento locativo y adecuaciones en Cali para empresas y copropiedades."
                />
                <meta property="og:url" content="https://espaciocompacto.com/blogs/" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />

                {/* 🔹 Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Blog de Mantenimiento Locativo en Cali" />
                <meta
                    name="twitter:description"
                    content="Guías y estrategias de mantenimiento locativo y SST en Cali."
                />
                <meta name="twitter:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />

                {/* 🔹 JSON-LD Blog */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Blog",
                        name: "Blog Espacio Compacto",
                        url: "https://espaciocompacto.com/blogs/",
                        description:
                            "Blog especializado en mantenimiento locativo, adecuaciones técnicas y cumplimiento SST en Cali, Colombia.",
                        publisher: {
                            "@type": "Organization",
                            name: "Espacio Compacto",
                            logo: {
                                "@type": "ImageObject",
                                url: "https://espaciocompacto.com/Espaci_Compacto.png"
                            }
                        }
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{ xs: 12, sm: 12, md: 12 }}
            >
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{ xs: 12, sm: 12, md: 10 }}
                    sx={{  px: 3, pt: 8 }}
                >
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="stretch"
                        size={{ xs: 12, sm: 12, md: 12 }}
                        sx={{ mt: 4 }}
                    >
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'center'}
                            size={{ xs: 12, sm: 12, md: 12 }}
                            sx={{ maxWidth: '1400px', pb: 8 }}
                        >
                            <Typography
                                component="h2"
                                sx={{
                                    color: "#223B59",
                                    fontSize: sCell ? "32px" : "48px",
                                    fontWeight: 600,
                                    lineHeight: 1.3,
                                    mt: 1,
                                }}
                            >
                                Blog
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'center'}
                            size={{ xs: 12, sm: 12, md: 12 }}
                        >
                            <Grid
                                container
                                justifyContent="center"
                                alignItems="center"
                                size={{ xs: 12, sm: 12, md: 12 }}
                                sx={{ pt: 8 }}
                            >
                                <Lista ids={["1", "2", "3"]} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                <Contacto_Home />
            </Grid>
        </>
    );
};

export default Blogs_Home;
